import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import smoothscroll from 'smoothscroll-polyfill'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLightbulb } from '@fortawesome/free-regular-svg-icons'
import {
  faBolt,
  faSitemap,
  faCogs,
  faBars,
  faAngleRight,
} from '@fortawesome/free-solid-svg-icons'

import 'normalize.css'

import favicon from '../assets/favicon.ico'
import pngIcon from '../assets/favicon.png'
import office from '../assets/office_opt.jpg'
import { Header, NavButton } from '../components/header'
import Footer from '../components/footer'
import './index.css'

// FA icons
library.add(faLightbulb)
library.add(faBolt)
library.add(faSitemap)
library.add(faCogs)
library.add(faBars)
library.add(faAngleRight)

class Layout extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    smoothscroll.polyfill()
  }

  render() {
    return (
      <div>
        <Helmet
          title={this.props.data.site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content:
                'Zinc is an ecommerce laboratory based in San Francisco, CA.',
            },
            {
              name: 'keywords',
              content:
                'ecommerce, amazon, dropshipping, consulting, saas, enterprise, ebay, listing',
            },
            { name: 'og:title', content: 'ZINC - the ecommerce laboratory' },
            {
              name: 'og:image',
              content: `${require('../assets/office_opt.jpg')}`,
            },
          ]}
        >
          <link
            href="https://fonts.googleapis.com/css?family=Roboto Slab:300,400,500|Roboto:100,300,400,500,700,900"
            rel="stylesheet"
          />
          <link
            rel="icon"
            type="image/x-icon"
            sizes="16x16 32x32"
            href={pngIcon}
          />
          <link
            rel="shortcut icon"
            type="image/x-icon"
            sizes="16x16 32x32"
            href={pngIcon}
          />
        </Helmet>
        <Helmet>
          <script async src="https://www.googletagmanager.com/gtag/js?id=G-JRMX4Z1HFY"></script>
          <script>
            {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-JRMX4Z1HFY');
            `}
          </script>
        </Helmet>
        <Header siteTitle={this.props.data.site.siteMetadata.title} />
        {this.props.children()}
        <NavButton />
        <Footer />
      </div>
    )
  }
}

export default Layout

export const siteQuery = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js